import { Record } from 'immutable';
import { actionTypes } from './auth.actions';
import { Err } from '../err';

export const AuthReducerState = Record({
  err: null,
  isAuthenticated: false,
  isFetching: false,
  authToken: null,
  currentSession: null
});

export const authReducer = (state = new AuthReducerState({
  authToken: localStorage.getItem('portalSetupAuthToken') || null
}), action) => {
  switch (action.type) {
    case actionTypes.INVALIDATE_CURRENT_SESSION:
      return state.set('isFetching', false)
                  .set('isAuthenticated', false)
                  .set('authToken', null);
    case actionTypes.INVALIDATE_CURRENT_SESSION_UNOBTRUSIVE:
      return state.set('isFetching', false)
                  .set('isAuthenticated', false)
                  .set('authToken', null);
    case actionTypes.FETCH_CURRENT_SESSION_BEGIN:
      return state.set('isFetching', true)
                  .set('currentSession', null)
                  .set('err', null);
    case actionTypes.FETCH_CURRENT_SESSION_SUCCESS:
      return state.set('isFetching', false)
                  .set('isAuthenticated', true)
                  .set('currentSession', action.data);
    case actionTypes.FETCH_CURRENT_SESSION_FAILURE:
    case actionTypes.VERIFY_CURRENT_SESSION_FAILURE:
      return state.set('isFetching', false)
                  .set('isAuthenticated', false)
                  .set('currentSession', null)
                  .set('authToken', null)
                  .set('err', action.err);
    case actionTypes.CREATE_ETO_SESSION_BEGIN:
      return state.set('err', null)
                  .set('isFetching', true);
    case actionTypes.CREATE_ETO_SESSION_SUCCESS:
      return state.set('err', null)
                  .set('authToken', action.data.token)
                  .set('isFetching', false);
    case actionTypes.CREATE_ETO_SESSION_FAILURE:
      return state.set('err', new Err(action.err))
                  .set('isFetching', false);
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/auth/auth.reducer.js